<app-mainscreen>
    <app-simple-page-heading [breadcrumbs]="['Dashboard > Agents']" title="Agents" ></app-simple-page-heading>
    <div style="height: 15px;" *ngIf="userType != '2' && userType != '3'">    
    </div>
    <div class="box_container mt-4 pt-2 rounded-bottom1-0" *ngIf="userType == '2' || userType =='3'">
      <div class="box-header mb-4 w-100 pl-2">
          <label class="m-0 box_title_22 pl-1"> Agents </label>
      </div>
      <div class="row w-100">
          <div class="col-md-3 position-relative" *ngIf="userType =='2'">
            <select id="distributorId" name="distributorId" placeholder=" " class="form-control input_" [(ngModel)]="distributorId" (change)="bindResellerDDL()">
              <option *ngFor="let dis of distributorList" [value]="dis.id">
                  {{dis.name}}
              </option>
              </select>
              <label for="distributorId" class="label_">Distributor</label>
          </div>
          <div class="col-md-3 position-relative" *ngIf="userType =='2' || userType =='3'">
            <select id="resellerId" name="resellerId" placeholder=" " class="form-control input_" [(ngModel)]="resellerId">
              <option *ngFor="let dis of resellerList" [value]="dis.id">
                  {{dis.name}}
              </option>
              </select>
              <label for="distributorId" class="label_">Reseller</label>
          </div>
          <div class="col-md-1">
            <app-custom-button text="Filter" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="filterAgentData()">                    
            </app-custom-button>
        </div>
      </div>
    </div>
    <app-table-view
    [visibleColumnData] = "visibleColumnData"
    [visibleColumnsId] = "visibleColumnsId"
    [graphdata]="graphdata"
    [graphHeader]="graphHeader"
    title="{{userType == '2' || userType == '3' ? '..' : 'Agents' }}"
    tableBackground="var(--grey3)"
    buttonTitle="Create Agent"
    [showIconButtonEnd]="true"
    [showPaginator]="true"  
    (onActionClick)="onActionClick($event)"
    (onCreateBtnClick)="onCreateBtnClick($event)"
    [canCreate]="canCreate"
    [canView]="canView"
    [canDelete]="canDelete"
    [canEdit]="canEdit"
    className="{{userType == '2' || userType == '3' ? 'rounded-top1-0' : ''}}"
    [canEditPermission]="canEditPermission"
    [PermissionDesc]="'Edit Product Permission'"
    [authKeyPermissionDesc]="'Edit Auth Key Configuration'"
    [canEditAuthKeyPermission]="canEditAuthKeyPermission"
    [showLoader]="showLoader"
    [tableId]="'agentList'"
  ></app-table-view>

  <div class="overlay" *ngIf="showActivateBlockPopup">
    <div class="popup2 position-relative col-md-4" [ngClass]="{'border border-danger':activateBlockAgentFormControls['status'].value == 1,'border border-success':activateBlockAgentFormControls['status'].value == 3}">
      <div class="modal-header tooltip_ py-1 text-white" [ngClass]="{'bg-danger':activateBlockAgentFormControls['status'].value == 1,'bg-success':activateBlockAgentFormControls['status'].value == 3}">
        <h3>{{activateBlockAgentFormControls['status'].value == 1 ? "Block" : "Activate"}} Agent</h3>
        <button type="button" class="close pull-right svg_white" aria-label="Close"  (click)="closePopup()">
          <span aria-hidden="true"></span>
       </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="activateBlockAgentForm">
          <span class="text-grey3" [ngClass]="{'text-danger': ((activateBlockFormSubmitted || activateBlockAgentFormControls['comment'].touched) && activateBlockAgentFormControls['comment'].errors?.['required'])}">Please provide reason for {{activateBlockAgentFormControls['status'].value == 1 ? "Block" : "Activate"}} Agent</span>
          <textarea id="comment"  rows="5" name="comment" placeholder=" " class="form-control input_" formControlName="comment"
              [ngClass]="{'border border-danger': ((activateBlockFormSubmitted || activateBlockAgentFormControls['comment'].touched) && activateBlockAgentFormControls['comment'].errors?.['required'])}"></textarea>
              <Span class="text-danger error_span pl-2 " *ngIf="((activateBlockFormSubmitted || activateBlockAgentFormControls['comment'].touched) && activateBlockAgentFormControls['comment'].errors?.['required'] )">
                  Comment is required.
              </Span>
          <div class="row mt-4">
            <div class="col-6">
              <app-custom-button className="w-100 justify-content-center btn_outline" text="Cancel" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="closePopup()"></app-custom-button> 
            </div>
            <div class="col-6">
              <app-custom-button className="w-100 justify-content-center " text="Proceed" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="proceedActiveBlockAgent()"></app-custom-button> 
            </div>
          </div>    
        </form>
      </div>
    </div>
  </div>

  <div class="overlay" *ngIf="showPermissionPopup">
    <div class="popup2 position-relative col-md-4">
      <div class="modal-header tooltip_ py-1 text-white">
        <h3>Insurance Product Permission</h3>
        <button type="button" class="close pull-right svg_white" aria-label="Close"  (click)="this.showPermissionPopup = false;">
          <span aria-hidden="true"></span>
       </button>
      </div>
      <div class="modal-body min-h-330 p-0">       
        <div class="col-9 position-relative" >
          <label class="box_title_18 w-100 mb-0 pb-2 mb-2"></label>
          <div class="">
              <app-multi-dropdown class="w-100 multiselect_custom input_" [items]="productList"
                  [showSearch]="true" [showAll]="true" [showStatus]="false"
                  (itemChange)="onMultiSelectChange($event)" 
                  placeholder=" " id="Product">
              </app-multi-dropdown>
              <label class="float-start required label_ms">Product</label>
          </div>
        </div>
        <div class="col-3 text-right position-absolute bottom-15 offset-sm-9">
          <app-custom-button text="Submit" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="SaveUpdateUserProductPermission()">
          </app-custom-button>
        </div>
      </div>
    </div>
  </div>

  <div class="overlay" *ngIf="showAuthKeyConfigurationPopup">
    <div class="popup2 position-relative col-md-4">
      <div class="modal-header tooltip_ py-1 text-white">
        <h3>Auth Key Configuration</h3>
        <button type="button" class="close pull-right svg_white" aria-label="Close"  (click)="this.showAuthKeyConfigurationPopup = false;">
          <span aria-hidden="true"></span>
       </button>
      </div>
      <div class="modal-body min-h-330  px-0 pt-4">       
        <form class="form needs-validation" [formGroup]="authKeyForm" novalidate="">
          <div class="col-12 position-relative">
              <input type="text"placeholder=" " class="form-control input_" formControlName="mobile" [readonly]='true' [disabled]="true">
              <label for="mobile" class="label_">Mobile Number</label>
          </div>
          <div class="col-12 position-relative">
              <input type="text"placeholder=" " class="form-control input_" formControlName="userId" [readonly]='true' [disabled]="true">
              <label for="userId" class="label_">User Id</label>
          </div>
          <div class="col-12 position-relative">
              <input type="text"placeholder="" class="form-control input_" formControlName="authKey" [readonly]='true' [disabled]="true">
              <label for="authKey" class="label_">Auth Key</label>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col position-relative" [ngClass]="{'mb-2':((authKeyFormControl['userKey'].touched  || submittedConfigForm) && !authKeyFormControl['userKey'].valid)}">
              <input type="text" id="userKey" name="userKey" placeholder=" " class="form-control input_" formControlName="userKey" (keypress)="alphaNumericOnly($event)" [minlength]="8"
              [ngClass]="{'border border-danger': ((authKeyFormControl['userKey'].touched  || submittedConfigForm) && !authKeyFormControl['userKey'].valid)}" onkeypress="if(this.value.length=='12') return false">
              <label for="userKey" class="label_">UserKey</label>
              <Span class="text-danger error_span" *ngIf="((authKeyFormControl['userKey'].touched || submittedConfigForm) && authKeyFormControl['userKey'].errors?.['required'])">
                  UserKey is required
              </Span>
              <Span class="text-danger error_span" *ngIf="((authKeyFormControl['userKey'].touched  || submittedConfigForm) && authKeyFormControl['userKey'].errors?.['minlength'])">
                  UserKey min length is 8.
              </Span>              
            </div>
            <div class="col-auto">
              <app-custom-button text="Generate AuthKey" [width]="'auto'" [height]="'38px'" className="btn_outline" [disabled]="!authKeyFormControl['userKey'].valid" leadingIconName="" (click)="GenerateAuthenticationKey()"></app-custom-button>
            </div>  
           </div> 
          </div> 
        </form>
        <div class="col-12 position-absolute bottom-15 right-0 d-flex justify-content-around">
          <app-custom-button text="Remove AuthKey" [width]="'auto'" [height]="'38px'" leadingIconName="" (click)="removeAuthKey()" className="btn_outline border-danger text-danger" *ngIf="isAuthkeyExists"></app-custom-button>
          <app-custom-button text="Update AuthKey" [width]="'auto'" [height]="'38px'" leadingIconName="" (click)="UpdateAuthKeyConfiguration()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
  <app-stepper-dialog></app-stepper-dialog>
  </app-mainscreen>